import { useState, useEffect } from "react";
import "./CookieBanner.css";
import { track } from "../../utils/analytics";

const CONSENT_KEY = "ckris_cookie_consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (!consent) {
      setVisible(true);
    } else if (consent === "accepted") {
      track("pageview");
    }
  }, []);

  function handleAccept() {
    localStorage.setItem(CONSENT_KEY, "accepted");
    setVisible(false);
    track("pageview");
  }

  function handleDecline() {
    localStorage.setItem(CONSENT_KEY, "declined");
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div className="cookie-banner" role="dialog" aria-label="Cookie toestemming">
      <div className="cookie-banner-inner">
        <div className="cookie-banner-text">
          <strong>Wij gebruiken cookies.</strong> Deze website gebruikt enkel
          analytische cookies om het bezoekersverkeer te meten. Er worden geen
          persoonlijke gegevens gedeeld met derden. Lees onze{" "}
          <a href="./privacy.pdf" target="_blank" rel="noopener noreferrer">
            privacyverklaring
          </a>{" "}
          voor meer informatie.
        </div>
        <div className="cookie-banner-actions">
          <button className="cookie-btn cookie-btn-decline" onClick={handleDecline}>
            Weigeren
          </button>
          <button className="cookie-btn cookie-btn-accept" onClick={handleAccept}>
            Accepteren
          </button>
        </div>
      </div>
    </div>
  );
}
